export default __webpack_public_path__ + "static/mac-video-ce0e7d05728174416d1d27559dc7b51e.mp4";